// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"90f4d22a","12":"f49168cb","203":"018ff01b","421":"83571726","518":"dcbf80e1","639":"ae9592d7","915":"346f1ba0","961":"8f58f56c"}[chunkId] + ".chunk.css";
};